interface EnvironmentUrls {
  local: string;
  qa: string;
  dev: string;
  prod: string;
}

// Define the base URL for each environment
const envUrls: EnvironmentUrls = {
  local: 'http://localhost:8080', // Local development server
  qa: 'https://api.mueda.co', // QA environment endpoint
  dev: 'https://api.mueda.co', // Development environment endpoint
  prod: 'https://api.mueda.co', // Production endpoint
};

// Force the environment variable to be one of the keys in EnvironmentUrls
const currentEnv: keyof EnvironmentUrls = (process.env.REACT_APP_ENV ||
  'local') as keyof EnvironmentUrls;

export const API_BASE_URL = envUrls[currentEnv];
